(function(_){
    'use strict';
    _['OUTLETS.KEY']='Ofertas';
    _['OUTLETS.NO-PROMOTIONS']='No hay ofertas disponibles';
}(translations['es']));


// WEBPACK FOOTER //
// ./src/app/modules/outlets/lang/outlets-lang_es.js